import { Injectable } from '@angular/core';
import { RestClientService } from 'src/app/core/services/rest/rest-client.service';
import { RequestItem } from '../model/request-item';
import { ConfirmerRequestItem } from '../model/confirmer-credit';
import { FaciliteCorporateDTO } from '../model/facilite-corporate-dto';

@Injectable({
    providedIn: 'root'
  })
  export class RequestItemService{

    constructor(private _restClientService : RestClientService) 
    {}

    
    getListRequestItemByRequest(requestId){
        return this._restClientService.load<RequestItem[]>('request-item/request-item-by-request?requestId='+requestId);
    }
  
    getRequestItemById(id) {
        return this._restClientService.load<RequestItem>('request-item/request-item-by-id/'+id);
    }
        
    putRequestItem(requestItem: RequestItem) {
        return this._restClientService.put<void>('request-item/update-request-item', requestItem);
    }
    
    confirmer(confirmerRequestItem: ConfirmerRequestItem) {
        return this._restClientService.put<void>('request-item/confirmer-credit', confirmerRequestItem);
    }
    
    findFacilitesCorporate(requestId){
        return this._restClientService.load<FaciliteCorporateDTO[]>('request-item/facilite-corporate-by-request?requestId='+requestId);
    }
  
    
}